import React, { FC } from 'react';
import { PictureProps } from '@v2/components/imageHandling/components/Picture';
import { Element, fullHeight, scale as initialScale } from '@components/frame';
import { isWeb } from '@helpers';
import NavigationArrow from './NavigationArrow';
import { NAVIGATION_ARROW_SIZE } from '@v2/components/imageHandling/constants';

interface NavigationArrowsProps extends Pick<PictureProps, 'C' | 'selectedIndex' | 'setSelectedIndex' | 'images' | 'height' | 'scale'> {
  showActions?: boolean;
}

export const NavigationArrows: FC<NavigationArrowsProps> = ({
  showActions = true,
  selectedIndex,
  setSelectedIndex,
  C,
  images,
  height = fullHeight,
  scale = initialScale,
}) => {
  if (!isWeb || !showActions) return null;

  const shouldDisplayLeftArrow = selectedIndex !== images.length - 1;
  const shouldDisplayRightArrow = selectedIndex !== 0;

  const elementSize = scale(NAVIGATION_ARROW_SIZE);
  const top = height / 2 - elementSize / 2;
  const horizontalOffset = scale(21);
  const zIndex = 100;

  const config = {
    top,
    height: elementSize,
    width: elementSize,
    zIndex,
  };

  return [
    shouldDisplayLeftArrow && (
      <Element key="LeftArrow" scale={scale} config={{ ...config, position: { left: horizontalOffset } }}>
        <NavigationArrow
          {...{
            C,
            height,
            scale,
            rotate: '0deg',
            onPress: () => {
              setSelectedIndex(selectedIndex + 1);
            },
          }}
        />
      </Element>
    ),
    shouldDisplayRightArrow && (
      <Element scale={scale} key="RightArrow" config={{ ...config, position: { right: horizontalOffset } }}>
        <NavigationArrow
          {...{
            C,
            height,
            scale,
            rotate: '180deg',
            onPress: () => {
              setSelectedIndex(selectedIndex - 1);
            },
          }}
        />
      </Element>
    ),
  ];
};

export default NavigationArrows;
